module.exports = __webpack_public_path__ + "img/Group 6854@2x.c3a02026.png";